import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation UpdateMosaicPageForDev(
    $tenantId: ID!
    $zoneId: ID!
    $identifier: FlexibleIdentifierInput!
    $updates: MosaicPageForDevUpdates!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          updatePage(identifier: $identifier, updates: $updates)
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.UpdateMosaicPageForDevMutation,
  undefined,
  graphql.schema.UpdateMosaicPageForDevMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
